.dialogContainer {
  height: 700px;
  border-radius: 16px;
  padding-top: 24px;
  background-repeat: no-repeat;
  background-size: 100% 80px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.dialogContent {
  height: 85%;
  padding-inline: 20px;
}
